export const ENTITY_MANAGER_TYPE_MODAL_CREATE = "MODAL_CREATE";
export const ENTITY_MANAGER_TYPE_LIST = "LIST";